import { render, staticRenderFns } from "./noticeManagement.vue?vue&type=template&id=0195e65f&scoped=true"
import script from "./noticeManagement.vue?vue&type=script&lang=js"
export * from "./noticeManagement.vue?vue&type=script&lang=js"
import style0 from "./noticeManagement.vue?vue&type=style&index=0&id=0195e65f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0195e65f",
  null
  
)

export default component.exports